/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { SET_LOCATION_URL } from './urlchangeevents.types';

export const setLocationUrlAction = (url: string): AnyAction => ({
    type: SET_LOCATION_URL,
    payload: {
        url,
    },
});
